import React, { Component } from 'react';
import InlineSVG from 'svg-inline-react';
import { connect } from 'react-redux';
import { openDrawer, closeDrawer } from 'actions/drawer';
import { addNotification } from 'actions/notifications';
import Dropzone from 'react-dropzone';
import ContentHeader from 'components/ContentHeader';
import ContentFooter from 'components/ContentFooter';

import { Terms } from '../../models';
import { validate } from '../../models/validate';

import { PanelSection, PanelSectionWithLabel } from 'components/PanelSections';
import Input from '../Input';
import Button from '../Button';

import { setObjPath, formatValue, keyedObjToArr } from '../../util';
import {firebaseConnect, helpers} from "react-redux-firebase";
const { dataToJS } = helpers;

const filesPath = 'files/terms';

class TermsConditionsPanel extends Component {

	//Need to move state to here
	constructor (props) {
		super(props);
		this.state = {
			terms : this.props.terms || {}
		};
	}

	updateTerms (event) {
		let value = formatValue(event.target.value, event.target.type);
		let terms = setObjPath(this.state.terms, event.target.name, value);
		this.setState({
            terms : terms
		});
	}

	updateTermsPdf(fileId, downloadURL) {
		let terms = this.state.terms;
        terms.pdf = fileId;
		this.setState({
			terms : terms,
            downloadURL: downloadURL
		});
	}

    onFileDrop (files) {
        console.log(files);
        const { firebase } = this.props;
        let dbPath = filesPath;
        firebase.uploadFile(filesPath, files[0], dbPath).then( (response)=> {
            console.log(response);
            this.updateTermsPdf(response.key, response.File.downloadURL);
        });
    }

    deleteFile (fileId) {
        const { firebase } = this.props;
        firebase.deleteFile(this.props.files[fileId].fullPath, `${filesPath}/${fileId}`).then( (response)=> {
            this.updateTermsPdf(null, null);
        });
    }

	render () {
		return (
			<div className="panel">
				<ContentHeader
					title={'Create New Terms & Conditions'}
					closeable="true"
					onClose={this.props.closeDrawer}
				/>
				<div className="panel-content">
					<div className="container">
						<div className="panel-section">
							<div className="panel-row">
								<div className="row tight">
									<div className="col-3">
										<label className="section-label for-large-input">Version</label>
									</div>
									<div className="col-9">
										<div className="section-content">
                                            <Input
                                                placeholder="Version"
                                                name="version"
                                                value={this.state.terms.version}
                                                onChange={this.updateTerms.bind(this)}
                                            />
										</div>
									</div>
								</div>
							</div>
							<div className="panel-row">
								<div className="row tight">
									<div className="col-3">
										<label className="section-label">PDF</label>
									</div>
									<div className="col-9">
										<div className="section-content">
                                            { this.state.downloadURL ? (
                                                <div>
                                                    <a className='button' href={this.state.downloadURL} target='_blank'>
                                                        Download
                                                    </a>
                                                    &nbsp;
                                                    <Button
                                                        label="Delete File"
                                                        onClick={this.deleteFile.bind(this, this.state.terms.pdf)}
                                                    />
                                                </div>
                                            ) : (
                                                <Dropzone
                                                    multiple={false}
                                                    accept="application/pdf, application/zip,application/octet-stream"
                                                    className="empty-area"
                                                    onDrop={this.onFileDrop.bind(this)}
                                                >
                                                    <div className="label">
                                                        <div className="text">
                                                            Drag and drop file here
                                                            or click to select
                                                        </div>
                                                    </div>
                                                </Dropzone>
                                            )}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<ContentFooter
					onClose={this.props.closeDrawer}
					onCancel={this.props.onCancel}
					onConfirm={ function () {
						validate(this.state.terms, Terms).then( (validatedTerms)=> {
                            this.props.addTerms(validatedTerms);
                            this.props.addNotification('add-save-terms-success-' + Date.now(), 'Terms Added');
                            this.props.closeDrawer();
						}).catch( (error)=> {
							console.log(error.message);
							this.props.addNotification('add-save-terms-error-' + Date.now(), error.message);
						});
					}.bind(this)}
					cancelLabel={this.props.cancelLabel}
					confirmLabel="Save Terms"
				/>
			</div>
		);
	}
}

const fbWrappedComponent = firebaseConnect()(TermsConditionsPanel);

const mapDispatchToProps = (dispatch) => {
	return {
		openDrawer :  (panel) => { dispatch(openDrawer(panel)); },
		closeDrawer : () => { dispatch(closeDrawer()); },
		addNotification : (key, message) => { dispatch(addNotification(key, message)); }
	};
};

export default connect(
    ({ firebase }) => ({
        files: dataToJS(firebase, 'files/terms')
    }),
	mapDispatchToProps
)(fbWrappedComponent);



// WEBPACK FOOTER //
// ./js/components/TermsConditions/TermsConditionsPanel.js